// Constants
import {
  MBS_AUTH_STORAGE_PREFIX,
  MBS_PENDING_AUTH_MESSAGE_KEY,
} from "Constants/AuthConstants";

const getStorageKey = (key) => `${MBS_AUTH_STORAGE_PREFIX}.${key}`;

/**
 * Storage implementation used by Amplify token provider for MBS auth.
 * Must match Amplify's expected interface of setItem, getItem, removeItem, and clear methods.
 */
export const mbsStorage = {
  setItem: (key, value) => {
    sessionStorage.setItem(getStorageKey(key), value);
    return sessionStorage.getItem(getStorageKey(key));
  },
  getItem: (key) => {
    return sessionStorage.getItem(getStorageKey(key));
  },
  removeItem: (key) => {
    sessionStorage.removeItem(getStorageKey(key));
    return undefined;
  },
  clear: () => {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(MBS_AUTH_STORAGE_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
  },
};

export const getPendingAuthMessage = () => {
  return {
    message:
      sessionStorage.getItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.message`) || "",
    severity:
      sessionStorage.getItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.severity`) ||
      "error",
  };
};

export const setPendingAuthMessage = (message, severity = "error") => {
  sessionStorage.setItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.message`, message);
  sessionStorage.setItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.severity`, severity);
};

export const clearPendingAuthMessage = () => {
  sessionStorage.removeItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.message`);
  sessionStorage.removeItem(`${MBS_PENDING_AUTH_MESSAGE_KEY}.severity`);
};
